.button {
    background: palegoldenrod;
    width: 48%;
    height: 2cm;
    /*
    z-index: 9;
    position: absolute; // Otherwise, it will be `static` and `z-index` will not be in effect.
    */
  }
